import Headroom from 'headroom.js';

export default function initHeadroom() {
    var header = document.querySelector('.sticky-header');
    var hero = document.querySelector('.hero-section');

    if (header && hero) {
        var offset = hero.clientHeight + header.clientHeight;
    } else if (header) {
        var offset = header.clientHeight;
    } else if (hero) {
        var offset = hero.clientHeight;
    } else {
        var offset = 0;
    }

    var options = {
        "offset": offset,
        "tolerance": 10,
        "onTop": function() {
            if(this.hasClass("pinned")){
                this.removeClass("pinned");
            };
        }
    };
    var headroom = new Headroom(header, options);
    headroom.init();

    var contactList = document.querySelector('.sticky-header .container-fluid .header-contact .contact-list');
    if(contactList.style.minHeight < header.clientHeight) {
        contactList.style.minHeight = header.clientHeight + "px";
    }
    
}
// This comment exists to force git to recongize a change and update